import { normalizeHeaderAudios } from './localAudio.js';

export const AUDIO_HEADER_TYPE = 'audio-header';

export function getAudioHeaderDefaults(extra = {}) {
	return normalizeAudioHeaderData({
		items: [],
		...extra,
	});
}

export function normalizeAudioHeaderData(data = {}) {
	return normalizeHeaderAudios(data);
}

export function isAudioHeaderBlock(type) {
	return type === AUDIO_HEADER_TYPE;
}
